import FieldType from '../../components/Form/Fields/type'
import { emailRequired } from '@polvo-labs/form-utils'

export interface ForgotFormData {
  email: string
}

export type ForgotForm = keyof ForgotFormData

const fields: FieldType<ForgotForm>[] = [
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'Informe seu email de cadastro no IPTU',
    },
    validation: emailRequired,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
    },
  },
]

export default fields
